module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-32-min.7fc0def0.jpg";